export default __webpack_public_path__ + "static/media/repair.2c4f4278.svg";